export default __webpack_public_path__ + "static/media/ID_4.4e0c2f19.png";